import { jeyhoonPhoneNumber } from './constants/global'

export const handlePhoneCall = () => {
  if (
    navigator.userAgent.match(
      /iPhone|iPad|iPod|Android|BlackBerry|Opera Mini|IEMobile/i,
    )
  ) {
    window.location.href = `tel:${jeyhoonPhoneNumber}`
  }
}
